import { Box, Chip } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

// "All" plus one chip per shop type tile (Restaurant, Grocery, Fashion &
// Beauty, ...). Tiles with no stores nearby are left out.
// The theme's text.primary is white (built for the dark header), so an
// outlined Chip would render white-on-white. Colours are set explicitly.
const chipSx = (active) => ({
  fontWeight: 600,
  fontSize: "0.9rem",
  height: 38,
  px: 1,
  borderRadius: "19px",
  color: active ? "#fff" : "#1f1f1f",
  borderColor: active ? "transparent" : "#D9D9D9",
  backgroundColor: active ? "primary.main" : "#fff",
  "&:hover": {
    backgroundColor: active ? "primary.main" : "#F5F5F5",
  },
  "&.MuiChip-clickable:hover": {
    backgroundColor: active ? "primary.main" : "#F5F5F5",
  },
});

function ShopTypeFilter({ shopTypes, counts, selected, onSelect }) {
  const { t } = useTranslation();
  const visible = shopTypes.filter((type) => counts[type.slug]);
  if (!visible.length) return null;
  return (
    <Box
      sx={{
        display: "flex",
        gap: 1,
        flexWrap: "wrap",
        justifyContent: "center",
        px: 2,
        marginBottom: 4,
        pt: 4,
        width: "100%",
      }}
    >
      <Chip
        label={t("all")}
        color={selected ? "default" : "primary"}
        variant={selected ? "outlined" : "filled"}
        onClick={() => onSelect(null)}
        sx={chipSx(!selected)}
      />
      {visible.map((type) => (
        <Chip
          key={type.slug}
          label={`${type.emoji ? `${type.emoji} ` : ""}${type.title} (${counts[type.slug]
            })`}
          color={selected === type.slug ? "primary" : "default"}
          variant={selected === type.slug ? "filled" : "outlined"}
          onClick={() => onSelect(selected === type.slug ? null : type.slug)}
          sx={chipSx(selected === type.slug)}
        />
      ))}
    </Box>
  );
}

export default ShopTypeFilter;
